import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
interface HubHeaderProps {
  crumb: string;
  meta: string;
  titleLead: string;
  titleItalic: string;
  deck: string;
}
export function HubHeader({
  crumb,
  meta,
  titleLead,
  titleItalic,
  deck
}: HubHeaderProps) {
  return <div className="mx-auto max-w-shell px-6 pb-14 pt-8 lg:px-10" data-id="element-126" data-mp="3f20a3lyejxc7">
      <nav aria-label="Breadcrumb" data-id="element-127" data-mp="2rausb18wiuz9">
        <ol className="flex items-center gap-2 text-[12.5px] text-muted" data-id="element-128" data-mp="2rbw81j0v45nb">
          <li data-id="element-129" data-mp="2mct0nrxetnc6">
            <Link to="/" className="hover:text-ink hover:underline" data-id="element-130" data-mp="2mdcjdauvwfr9">
              Home
            </Link>
          </li>
          <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-131" data-mp="3128nwxxqfan4" />
          <li aria-current="page" className="text-ink" data-id="element-132" data-mp="2w962jd33z7i0">
            {crumb}
          </li>
        </ol>
      </nav>

      <div className="mt-12 max-w-3xl" data-id="element-133" data-mp="28j20vb9hdhtn">
        <p className="label text-olive" data-id="element-134" data-mp="23ljofaw98kgw">{meta}</p>
        <h1 className="mt-6 font-display text-[48px] font-300 leading-[0.98] text-ink sm:text-[64px]" data-id="element-135" data-mp="23kqsz62qxhe2">
          {titleLead} <span className="italic" data-id="element-136" data-mp="1h1119nke3by1">{titleItalic}</span>
        </h1>
        <p className="mt-7 max-w-prose text-[16px] leading-[1.85] text-muted" data-id="element-137" data-mp="1lzcabw2v1if7">
          {deck}
        </p>
      </div>
    </div>;
}